/*
* This is a patch for gridstack engine
* */
import {GridStack, GridStackEngine, Utils} from "gridstack";


export class ConvrrtGridStackEngine extends GridStackEngine {
    lockNodes () {
        this.nodes.forEach(x => {
            x.locked = true;
            x._dirty = true; // will force attr update
        })
    }

    unLockNodes () {
        this.nodes.forEach(x => {
            x.locked = false;
            x._dirty = true; // will force attr update
        })
    }
    /** return true if the passed in node was actually moved (checks for no-op and locked) **/
    moveNode(node, o) {
        if (!node || /*node.locked ||*/ !o) return false;
        if (o.pack === undefined) o.pack = true;

        // constrain the passed in values and check if we're still changing our node
        if (typeof o.x !== 'number') { o.x = node.x; }
        if (typeof o.y !== 'number') { o.y = node.y; }
        if (typeof o.w !== 'number') { o.w = node.w; }
        if (typeof o.h !== 'number') { o.h = node.h; }
        let resizing = (node.w !== o.w || node.h !== o.h);
        let nn = Utils.copyPos({}, node, true); // get min/max out first, then opt positions next
        Utils.copyPos(nn, o);
        nn = this.nodeBoundFix(nn, resizing);
        Utils.copyPos(o, nn);

        if (Utils.samePos(node, o)) return false;
        let prevPos = Utils.copyPos({}, node);

        // check if we will need to fix collision at our new location
        let collides = this.collideAll(node, nn, o.skip);
        let needToMove = true;
        if (collides.length) {
            // now check to make sure we actually collided over 50% surface area while dragging
            let collide = node._moving && !o.nested ? this.collideCoverage(node, o, collides) : collides[0];
            // if (collide && o.resizing) {
            //     // we want the component to remain where they are since its colliding with other nodes
            //     needToMove = false;
            // }
            if (collide) {
                needToMove = !this._fixCollisions(node, nn, collide, o); // check if already moved...
            } else {
                needToMove = false; // we didn't cover >50% for a move, skip...
            }
        }

        // now move (to the original ask vs the collision version which might differ) and repack things
        if (needToMove) {
            node._dirty = true;
            Utils.copyPos(node, nn);
        }
        if (o.pack) {
            this._packNodes()
                ._notify();
        }
        return !Utils.samePos(node, prevPos); // pack might have moved things back
    }

    /** return true if the passed in node was actually moved (checks for no-op and locked) **/
    getNodeCollision(node, o) {
        if (o.pack === undefined) o.pack = true;

        // constrain the passed in values and check if we're still changing our node
        if (typeof o.x !== 'number') { o.x = node.x; }
        if (typeof o.y !== 'number') { o.y = node.y; }
        if (typeof o.w !== 'number') { o.w = node.w; }
        if (typeof o.h !== 'number') { o.h = node.h; }
        let resizing = (node.w !== o.w || node.h !== o.h);
        let nn = Utils.copyPos({}, node, true); // get min/max out first, then opt positions next
        Utils.copyPos(nn, o);
        nn = this.nodeBoundFix(nn, resizing);
        Utils.copyPos(o, nn);

        // check if we will need to fix collision at our new location
        return this.collideAll(node, nn, o.skip);
    }
}

GridStack.registerEngine(ConvrrtGridStackEngine)

